import { render } from "./UserProjects.vue?vue&type=template&id=5e55ff7e"
import script from "./UserProjects.vue?vue&type=script&lang=js"
export * from "./UserProjects.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__